// extracted by mini-css-extract-plugin
export default {"body":"counsellorempower_body__SGUnd","content":"counsellorempower_content__6X9yx","potential":"counsellorempower_potential__lVtO5","photo":"counsellorempower_photo__+18M-"};